import type { Article, Award, MediaMention } from '../contexts/LanguageContext';

export interface PublicPageData {
  path: string;
  language: 'bg' | 'en';
  articles: Article[];
  awards: Award[];
  mediaMentions: MediaMention[];
}

export function serializeJsonForScript(value: unknown): string {
  const serialized = JSON.stringify(value) ?? 'null';
  return serialized
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
}

export function isPublicPageData(value: unknown): value is PublicPageData {
  if (!value || typeof value !== 'object') return false;
  const data = value as Partial<PublicPageData>;
  return typeof data.path === 'string'
    && (data.language === 'bg' || data.language === 'en')
    && Array.isArray(data.articles)
    && Array.isArray(data.awards)
    && Array.isArray(data.mediaMentions);
}
